/* eslint-disable import/no-anonymous-default-export */
export default {
  "projectItem.name": "Name",
  "projectItem.version": "Revision",
  "projectItem.owner": "Owner",
  "projectItem.description": "Description",
  "projectItem.updated_at": "Update Date",
  "projectItem.created_at": "Date",
  "projectItem.download": "Download",
  "projectItem.delete": "Delete",
  "projectItem.folderRoot": "Root Folder",
  "projectItem.new_folder": "New Folder",
  "projectItem.upload": "Upload",
  "projectItem.add": "Add File",
  "projectItem.update": "Update",
  "projectItem.input.remove": "Remove",
  "projectItem.input.required": "Required field",
  "projectItem.menuItem.Download": "Download",
  "projectItem.menuItem.share": "Share",
  "projectItem.menuItem.details": "Details",
  "projectItem.menuItem.view": "View",
  "projectItem.menuItem.personalize": "Customize",
  "projectItem.menuItem.personalize.folderColor": "Folder color",
  "projectItem.search": "Search",
  "projectItem.listFile": "File List",
  "projectItem.revision.place.extern": "External revision",
  "projectItem.revision.numeric.help":
    "File revisions must follow the pattern R00, R01, R99.",
  "projectItem.revision.alphabetical.help":
    "File revisions must follow the pattern RA, RB, RCZ.",
  "projectItem.revision.doubleNumeric.help":
    "File revisions must follow the pattern R00.00, R01.01, R99.99.",
  "projectItem.validation.description": "Enter the description",
  "projectItem.validation.revision": "Enter the revision",
  "projectItem.placeholder.description": "Content description",
  "projectItem.placeholder.description.file": "File description",
  "projectItem.placeholder.description.folder": "Folder description",
  "projectItem.modal.send": "Send",
  "projectItem.modal.cancel": "Cancel",
  "projectItem.modal.revisionInfo":
    "When registering a file with a new revision, it will be automatically replaced",
  "projectItem.error": "Some error occurred",
  "projectItem.upload.dropText": "Drag files here",
  "projectItem.upload.dropHint": "Or click here and search",
  "projectItem.pathTaken": "Path taken",
  "projectItem.drawerDetails.title": "Details",
  "projectItem.drawerDetails.folder": "Folder details",
  "projectItem.drawerDetails.folderName": "Folder name",
  "projectItem.drawerDetails.files": "File details",
  "projectItem.drawerDetails.fileName": "File name",
  "projectItem.drawerDetails.owner": "Owner",
  "projectItem.drawerDetails.from": "By",
  "projectItem.drawerDetails.modified": "Modified on",
  "projectItem.drawerDetails.lastVersions": "Last versions",
  "projectItem.drawerDetails.historic": "History",
  "projectItem.drawerDetails.ative": "Active",
  "projectItem.drawerDetails.copy": "Copied",
  "projectItem.drawerDetails.downloadLastVersion": "Download latest version",
  "projectItem.drawerDetails.download.withoutRevision":
    "The revision will not be included in the file name using this download.",
  "projectItem.error.maxNameLength":
    "Name with size above the character limit.",
  "projectItem.line1": "Manage your projects with more",
  "projectItem.highlight1": "organization",
  "projectItem.and": "and",
  "projectItem.highlight2": "security!",
  "projectItem.link": "Click here",
  "projectItem.line3": "and have it in your company too.",
  "projectItem.headerTagline":
    "Manage your projects with more organization and security!",
  "projectItem.ctaJoinplace": "Discover Joinplace",
};
